<template>
    <div class="newsList">
        <div class="newsHead">
            <div class="newsLogo">开源资讯</div>
            <div class="moreNews" @click="openNews" title="查看更多">查看更多 > </div>
        </div>
        <ul>
            <li v-bind:key="index" v-for="(item, index) in news" >
                <a :href="item.originUrl" target="_blank">
                    <div class="news" :title="item.title">
                        <h2 class="title">{{item.title}}</h2>
                        <p class="dec">{{item.intro}}</p>
                    </div>
                    <span class="newsTime">{{item.ctime.substring(0,10)}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props:['news'],
    methods: {
        openNews(){
            this.$router.push({ name: 'NewsList'})
        },
        openDeatil(){
            window.open("/oss/detail");
        }
    },
}
</script>
<style lang="less">
.newsList{
    max-width: 1320px;
    margin: 30px auto;
    overflow: hidden;
    .newsHead{
        width: 100%;
        height: 30px;
        .newsLogo{
            color: #043483;
            float: left;
            height: 26px;
            line-height: 26px;
            border: 1px solid #043483;
            border-radius: 18px;
            padding: 0 20px;
        }
        .moreNews{
            height: 36px;
            line-height: 36px;
            float: right;
            cursor: pointer;
            /* text-decoration: underline; */
            /* color: #0079dd; */
            color: #043483;
            font-size: 14px;
        }
    }
    ul{
        li{
            border-bottom: 1px solid #eee;
            padding: 20px 0;
            list-style-type: none;
            overflow: hidden;
            width: 100%;
            &:first-child {
                padding-top: 12px;
            }
            a{
                text-decoration: none;
                color: #000;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .news{

                float: left;
                max-width: 1160px;
                .title{
                    font-size: 16px;
                }
                .title:hover{
                    text-decoration: underline;
                }
                .dec{
                    margin-top: 2px;
                    font-size: 14px;
                    color: #555;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
            .newsTime{
                // height: 60px;
                // line-height: 60px;
                // float: right;
                color: #666;
                // width: 82px;
                font-size: 14px;
            }
        }
        li:hover{
            background: #fafafa;
            cursor: pointer;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/common/news-list/index.vue